import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=dda18b5a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=dda18b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda18b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda18b5a')) {
      api.createRecord('dda18b5a', component.options)
    } else {
      api.reload('dda18b5a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=dda18b5a&scoped=true&", function () {
      api.rerender('dda18b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ct3aCbIB7dap/JS/comp/DocBox.vue"
export default component.exports